import { render, staticRenderFns } from "./LimitMenu.vue?vue&type=template&id=712971f1&"
import script from "./LimitMenu.vue?vue&type=script&lang=js&"
export * from "./LimitMenu.vue?vue&type=script&lang=js&"
import style0 from "./LimitMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports